export default __webpack_public_path__ + "static/media/inside-wash.c67703df.jpg";